export default function (state, data) {
    state.items = [];
    state.time = new Date().getTime() + (60 * 60 * 1000);
    if (data && data.MainDialogFields && data.QuickEditFields) {
        let max = {};
        data.MainDialogFields.forEach(i => {
            switch (i.FieldName) {
                case 'Mobile_Number':
                    max.mobile = getRules(i);
                    break;
                default:
                    max[i.FieldName] = getRules(i);
            }
        });
        state.max = max;
        let min = {};
        data.QuickEditFields.forEach(i => {
            switch (i.FieldName) {
                case 'Mobile_Number':
                    min.mobile = getRules(i);
                    break;
                default:
                    min[i.FieldName] = getRules(i);
            }
        });
        state.min = min;
    } else {
        state.time = 0;
    }
    state.loading = false;
    state.cbs.forEach(i => {
        i(state);
    });
    state.cbs = [];
}

function getRules(i) {
    switch (i.FieldName) {
        case 'PassportDate':
        case 'PassportDateEnd':
        case 'PassportRusDate':
        case 'Birthday':
            return [
                {required: i.IsRequired, message: 'Введите дату', trigger: 'blur'},
            ];
        case 'CitizenId':
        case 'Gender':
        case 'AgeCategory':
            return [
                {required: i.IsRequired, message: 'Выберите выриант', type: 'number', trigger: 'blur,change'},
            ];
        case 'Constant':
        case 'IsSendSMS':
        case 'IsSendEmail':
            return [
                {required: i.IsRequired, message: 'Введите данные', type: 'boolean', trigger: 'blur'},
            ];
        case 'Mobile_Number':
        case 'Phone':
            return [
                {required: i.IsRequired, message: 'Введите номер', trigger: 'change'},
            ];
        case 'Email':
            return [
                {required: i.IsRequired, message: 'Введите данные', trigger: 'blur'},
                {type: 'email', message: 'Введите корректный e-mail', trigger: 'blur,change'},
                {max: i.MaxLength, message: 'Не более ' + i.MaxLength + ' символов', trigger: 'blur'},
            ];
        default:
            return [
                {required: i.IsRequired, message: 'Введите данные', trigger: 'blur'},
                {max: i.MaxLength, message: 'Не более ' + i.MaxLength + ' символов', trigger: 'blur'},
            ];
    }
}